import { Component, ErrorHandler, ChangeDetectionStrategy, signal } from '@angular/core'
import { form, maxLength } from '@angular/forms/signals'
import { MatDialogRef } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar'

import { FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { callLlmLuottokorttilasku } from '../llm-luottokorttilasku.client'

export interface LuoLuottokorttilaskuPromptDialogResult {
  promptiId: string
}

interface PromptiLomake {
  nimi: string
  sisalto: string
}

@Component({
  templateUrl: './luo-luottokorttilasku-prompt.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LuoLuottokorttilaskuPromptDialog {
  lomake = form(signal<PromptiLomake>({ nimi: '', sisalto: '' }), polku => {
    maxLength(polku.nimi, 120)
  })
  readonly tallennetaan = signal(false)

  constructor(
    private _dialogRef: MatDialogRef<LuoLuottokorttilaskuPromptDialog, LuoLuottokorttilaskuPromptDialogResult | undefined>,
    private _firebase: FirebaseLemonator,
    private _snackbar: MatSnackBar,
    private _errorHandler: ErrorHandler,
  ) {}

  async luo() {
    if (this.tallennetaan()) {
      return
    }
    const nimi = this.lomake.nimi().value().trim()
    const sisalto = this.lomake.sisalto().value()
    if (!nimi || !sisalto.trim()) {
      this._snackbar.open('Nimi ja sisältö ovat pakollisia', 'OK', { duration: 5000 })
      return
    }
    this.tallennetaan.set(true)
    try {
      const vastaus = await callLlmLuottokorttilasku(this._firebase, 'luoPrompt', { nimi, sisalto })
      if (vastaus.e || !vastaus.promptiId) {
        this._snackbar.open('Luonti epäonnistui: ' + (vastaus.e ?? 'tuntematon virhe'), 'OK', { duration: 8000 })
        return
      }
      this._snackbar.open('Prompti luotu', 'OK', { duration: 5000 })
      this._dialogRef.close({ promptiId: vastaus.promptiId })
    } catch (err) {
      this._errorHandler.handleError(err)
      this._snackbar.open('Luonti epäonnistui', 'OK', { duration: 8000 })
    } finally {
      this.tallennetaan.set(false)
    }
  }

  peruuta() {
    if (this.tallennetaan()) {
      return
    }
    this._dialogRef.close()
  }
}
